import styled from 'styled-components';

import { media } from 'src/styles/breakpoints';

export const StyledSidebar = styled.aside<{ $isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  flex-shrink: 0;
  z-index: 1;
  transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1);
  border-radius: 0.5rem;
  background: ${({ theme }) => theme.background};
  border: 1px solid ${({ theme }) => theme.grey};
  box-sizing: border-box;
  overflow-x: hidden;

  & > ul {
    margin: 0 0 4vh;
  }

  & > ul > li > a > button {
    /* The gap lives on StyledSidebarButton; setting it again here only
       shadowed it and cost the label ~7px of room. */
    cursor: pointer;
    width: 100%;
  }

  & > ul > li {
    list-style: none;
    cursor: pointer;
    border-radius: 3.5rem;
  }

  ${media.md} {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 250;
    height: 100dvh;
    width: min(18rem, 88vw);
    max-width: 100%;
    margin: 0;
    border-radius: 0;
    border-right: 1px solid ${({ theme }) => theme.grey};
    border-left: none;
    border-top: none;
    border-bottom: none;
    transform: translateX(${({ $isOpen }) => ($isOpen ? '0' : '-100%')});
    overflow-y: auto;
    overscroll-behavior: contain;
    padding-top: max(4.5rem, calc(env(safe-area-inset-top) + 3.5rem));
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.12);
  }

  ${media.upMd} {
    transform: none !important;
    align-self: stretch;
    min-height: 100%;
    width: 15rem;
    max-width: 15rem;
  }
`;

export const StyledList = styled.ul`
  padding: 1.5rem 1rem;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;

  li {
    min-width: 0;
    width: 100%;
  }

  a {
    text-decoration: none;
    cursor: pointer;
  }

  ${media.md} {
    padding: 1rem 0.75rem 2rem;
    margin: 0;
  }
`;

export const StyledManagementGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
`;

export const StyledManagementLabel = styled.span`
  flex: 1;
  min-width: 0;
  padding-right: 0.125rem;
`;

export const StyledManagementToggle = styled.button<{ $isActive: boolean }>`
  border: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  min-width: 0;
  background: none;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: inherit;
  font-family: inherit;
  color: ${({ theme }) => theme.dark};
  padding: 0.25rem 0;
  cursor: pointer;
  text-align: left;
  box-sizing: border-box;

  &:hover {
    background: ${({ theme }) => theme.primary90};
    color: ${({ theme }) => theme.primary};
  }

  ${({ $isActive, theme }) =>
    $isActive &&
    `
    background: ${theme.primary90};
    color: ${theme.primary};
  `}
`;

export const StyledManagementChevron = styled.span`
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 0.75rem;
  height: 0.75rem;
  color: inherit;

  svg {
    display: block;
    width: 0.75rem;
    height: 0.75rem;
    flex-shrink: 0;
  }
`;

export const StyledManagementSubListWrap = styled.div<{ $expanded: boolean }>`
  display: grid;
  grid-template-rows: ${({ $expanded }) => ($expanded ? '1fr' : '0fr')};
  margin-left: 2.25rem;
  transition: grid-template-rows 0.28s cubic-bezier(0.22, 1, 0.36, 1);
  overflow: hidden;

  ${media.md} {
    margin-left: 1.75rem;
  }
`;

export const StyledManagementSubListInner = styled.div`
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-top: 0.25rem;
`;

export const StyledManagementSubList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  a {
    text-decoration: none;
  }
`;

export const StyledManagementSubItem = styled.span<{ $isActive: boolean }>`
  display: block;
  padding: 0.35rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: ${({ theme, $isActive }) => ($isActive ? theme.primary : theme.midGrey)};
  background: ${({ theme, $isActive }) => ($isActive ? theme.primary90 : 'transparent')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    color: ${({ theme }) => theme.primary};
    background: ${({ theme }) => theme.primary90};
  }
`;
